<template>
    <el-time-select
    :disabled="disabled"
      :placeholder="placeholder"
      v-model="modelData[item.prop]"
      :picker-options="{
        start: item.start || '00:00',
        step: item.step || '00:01',
        end: item.end || '23:59',
        minTime: item.minDate,
        maxTime: item.maxDate
      }" />
</template>

<script>
export default {
  props: ['item', 'modelData'],
  data() {
    return {
      disabled: this.item.disabled,
      placeholder: `请输入 ${this.item.label}`
    }
  }
}
</script>
